import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AppContext } from '../../appProvider';

export default function PrivateComponents({children,...rest}) {
    const location = useLocation();
    const {isAuthenticatedClient, role} = useContext(AppContext);
    return isAuthenticatedClient && role == "ADMIN" ? children : <Navigate to="/admin/identification"  state={{from:location}} replace={true}/>
}